import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../firebase';
import { signInWithRedirect, getRedirectResult } from 'firebase/auth';
import logo from '../assets/logo.png';

const containerStyle = {
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#f9f9f9'
};

const boxStyle = {
  textAlign: 'center',
  background: 'white',
  padding: '2rem',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
};

const buttonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '0.75rem 1rem',
  borderRadius: '8px',
  width: '100%',
  maxWidth: '260px',
  margin: '0 auto 1rem',
  fontWeight: 'bold'
};

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    // Obtém o resultado do login após o redirecionamento
    getRedirectResult(auth)
      .then((result) => {
        if (result) {
          const user = result.user;

          localStorage.setItem("user", JSON.stringify({
            uid: user.uid,
            email: user.email,
            displayName: user.displayName
          }));

          navigate('/dashboard'); // Ou '/admin' se for necessário
        }
      })
      .catch((error) => {
        console.error("Erro ao obter resultado do login:", error);
      });
  }, [navigate]);

  const loginWithGoogle = () => {
    signInWithRedirect(auth, googleProvider);
  };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: '120px', marginBottom: '1rem' }} />
        </div>
        <h2 style={{ margin: '0 0 0.5rem', fontSize: '2rem', fontWeight: 'bold' }}>Bolão do Chico</h2>
        <button onClick={loginWithGoogle} style={{ ...buttonStyle, background: 'white', color: '#333', border: '1px solid #ccc' }}>
          <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" style={{ width: '20px', height: '20px', background: 'white', borderRadius: '50%' }} />
          Entrar com Google
        </button>
      </div>
    </div>
  );
}
